export default __webpack_public_path__ + "static/media/close-icon.fb83fcea.svg";